import React from 'react';

const Loader = () => {
    return (
        <div className="content">
            <div className="column">
                <div><img src="/images/Loader.gif" alt="Wallet-Payment" /></div>
            </div>
        </div>
    )
}

export default Loader;